<template>
  <form class="user-token-form" @submit="handleSubmit">
    <h2 class=" text-grey-darkest my-4">Add Legacy user</h2>
    <div class="row">
      <label for="user-id">Email</label>
      <input
        id="user-id"
        v-model="userEmail"
        class="userid-input"
        autofocus="true"
        type="email"
        required
        placeholder="Enter email of user"
      />
    </div>
    <div class="row">
      <label for="user-first-name">First Name</label>
      <input
        id="user-first-name"
        v-model="userFirstName"
        class="userid-input"
        type="text"
        required
        placeholder="Enter first name of user"
      />
    </div>
    <div class="row">
      <label for="user-last-name">Last Name</label>
      <input
        id="user-last-name"
        v-model="userLastName"
        class="userid-input"
        type="text"
        required
        placeholder="Enter last name of user"
      />
    </div>
    <div class="row">
      <label for="user-name">Password</label>
      <input
        id="password"
        v-model="password"
        class="userid-input"
        type="text"
        required
        placeholder="Enter random generated password to share with user"
      />
    </div>
    <div class="row">
      <label for="select-role"
        >Select role(s) to assign <small>(Optional)</small></label
      >
      <VueSelect
        id="select-role"
        class="w-full"
        label="name"
        :options="allRoles"
        :reduce="d => d.name"
        :value="selectedRoles"
        multiple
        @input="handleRolesInput"
      />
    </div>
    <div class="row text-center">
      <button
        class="p-3 shadow-md px-12 rounded-full mt-6 border-none text-white font-bold bg-green"
      >
        Create User
      </button>
    </div>
  </form>
</template>

<script>
import VueSelect from "vue-select"
import siteConfig from "@/utils/siteConfig"

export default {
  components: {
    VueSelect,
  },
  data() {
    return {
      userEmail: undefined,
      userFirstName: undefined,
      userLastName: undefined,
      password: undefined,
      preferences: undefined,
      allRoles: [],
      selectedRoles: [],
    }
  },
  created() {
    this.fetchAllRoles()
  },
  methods: {
    fetchAllRoles() {
      this.axios({
        method: "get",
        url: `${siteConfig.siteURL}admin/roles?pagination=false`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      })
        .then(res => {
          this.allRoles = res.data.items
        })
        .catch(err => {
          this.$noty.error(
            `Couldn't not get all roles from server, server responded with: ${err}`
          )
        })
    },

    handleRolesInput(options) {
      this.selectedRoles = options
    },

    handleSubmit(e) {
      e.preventDefault()
      const data = {
        email: this.userEmail,
        password: this.password,
        first_name: this.userFirstName,
        last_name: this.userLastName,
        roles: this.selectedRoles.map(r => r.id),
      }

      this.axios({
        method: "post",
        url: `${siteConfig.siteURL}users/register/legacy`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
        data,
      })
        .then(res => {
          if (!res.data.status) {
            throw res.data.error_message
          }
          this.$noty.success("Successfully created legacy user!", {
            layout: "topRight",
            theme: "relax",
          })
        })
        .catch(err => {
          this.$noty.error(`Failed creating legacy user! ${err}`, {
            layout: "topRight",
            theme: "relax",
          })
        })
    },
  },
}
</script>
<style scoped>
.user-token-form {
  max-width: 500px;
  margin: auto;
  margin-top: 80px;
  text-align: left;
}
.user-token-form input {
  width: 100%;
  margin-bottom: 1rem;
  padding: 10px;
  border-radius: 5px;
}
.user-token-form > input:focus {
  border: 2px solid green;
}
.user-token-form label {
  font-size: 1rem;
}
.user-info-container {
  width: 600px;
  margin: auto;
  text-align: center;
}
.user-info-container > label {
  display: block;
  padding: 10px;
  font-size: 16px;
  text-align: center;
}
</style>
